// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1f5oQ","newExpiryDate":"styles_newExpiryDate__1qfrg","footer":"styles_footer__3INtr"};